import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Redirect,Accordion,
    Tabs, Tab
} 
from '../../noser-hris-component';
import { Button as DxButton } from "devextreme-react/button";
import 'bootstrap/dist/css/bootstrap.min.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
//import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";

class PayfileMonitoring extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            monitoringPayrollData: [],
            filteredData: [],
            expandedRows: [],
            isloading: false,
            isshow: false,
            alerttype: "",
            message: "",
            color: "",
            fade: true,
            openModal: false,
            disableBtn: true,
            expandedRows: [],
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.handleClear = this.handleClear.bind(this);
        
        this.parentColumn = [
            {
                dataField: 'client',
                text: 'Client',
                editable: false,
                style: { textAlign: 'left', fontSize: "11px" },
                className: 'no-text-transform',
                headerStyle: () => {
                    return { textAlign: 'center', width: "15%", backgroundColor: 'green', color: 'white', fontSize: "11px"};
                },
            },
            {
                // dataField: 'payFileId',
                dataField: 'paycardType',
                text: 'Paycard Type',
                editable: false,
                sort: true,
                style: { textAlign: 'center', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "15%", backgroundColor: 'green', color: 'white', fontSize: "11px" };
                },
            },
            {
                dataField: 'payrollPeriod',
                text: 'Payroll Period',
                editable: false,
                style: { textAlign: 'center', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "20%", backgroundColor: 'green', color: 'white', fontSize: "11px" };
                },
            },
            {
                dataField: 'numberOfMembers',
                text: '# of Member',
                editable: false,
                style: { textAlign: 'center', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "15%", backgroundColor: 'green', color: 'white', fontSize: "11px" };
                },
            },
            {
                dataField: 'totalAmount',
                text: 'Total Amount',
                editable: false,
                style: { textAlign: 'right', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "15%", backgroundColor: 'green', color: 'white', fontSize: "13px", whiteSpace: "normal", verticalAlign: "middle" };
                },
                formatter: (cell) => {
                    return cell.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
            },
            {
                dataField: 'reference',
                text: 'Reference',
                editable: false,
                style: { textAlign: 'center', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%", backgroundColor: 'green', color: 'white', fontSize: "11px", whiteSpace: "normal", verticalAlign: "middle" };
                },
            },
            {
                dataField: 'action',
                text: 'Action',
                editable: false,
                style: { textAlign: 'center', fontSize: "11px" },
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%", backgroundColor: 'green', color: 'white', fontSize: "11px" };
                },
                formatter: (cell, row) => {
                    const csvData = [
                        // Parent row data
                        {
                            client: row.client,
                            paycardType: row.paycardType,
                            payrollPeriod: row.payrollPeriod,
                            numberOfMembers: row.numberOfMembers,
                            totalAmount: row.totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                            reference: row.reference
                        },
                        // Blank row for separation
                        {
                            client: '',
                            paycardType: '',
                            payrollPeriod: '',
                            numberOfMembers: '',
                            totalAmount: '',
                            reference: ''
                        },
                        // Member details
                        ...row.parentDetails.map(detail => ({
                            members: detail.name,
                            payrollPeriod: detail.payrollPeriod,
                            paycard: detail.paycard,
                            amount: detail.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                            status: detail.status
                        }))
                    ];
                
                    return (
                        <div style={{ textAlign: "center" }}>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`} style={{ fontSize: "12px" }}>
                                        Download
                                    </Tooltip>
                                }
                            >
                                <span style={{ marginRight: "10px" }}>
                                    {/* <CSVLink data={csvData} filename={`${row.client}_payfile.csv`}>
                                        Download
                                    </CSVLink> */}
                                    <a href='#' onClick={(e) => { e.preventDefault(); this.handleExcelDownload(row); }} >Download</a>
                                </span>
                            </OverlayTrigger>
                            {/* <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id={`tooltip-top`} style={{ fontSize: "12px" }}>
                                        View
                                    </Tooltip>
                                }
                            >
                                <span>
                                    <a href='#'>View</a>
                                </span>
                            </OverlayTrigger> */}
                        </div>
                    );
                }
            }
        ];

        this.parentDetailsColumn = [
            {
                dataField: 'name',
                text: 'Members',
                editable: false,
                style: { textAlign: 'left', fontSize: '11px' },
                headerStyle: () => {
                    return { textAlign: 'center', width: "25%", backgroundColor: '#12a420', color: 'white', fontSize: "11px" };
                },
            },
            // {
            //     // dataField: 'payfileId',
            //     dataField: 'paycardType',
            //     text: 'Paycard Type',
            //     editable: false,
            //     style: { textAlign: 'center', fontSize: '13px' },
            //     headerStyle: () => {
            //         return { textAlign: 'center', width: "15%", backgroundColor: '#12a420', color: 'white', fontSize: "14px", fontWeight: "normal" };
            //     },
            // },
            {
                dataField: 'payrollPeriod',
                text: 'Payroll Period',
                editable: false,
                style: { textAlign: 'center', fontSize: '11px' },
                headerStyle: () => {
                    return { textAlign: 'center', width: "20%", backgroundColor: '#12a420', color: 'white', fontSize: "11px" };
                },
            },
            {
                dataField: 'paycard',
                text: 'Paycard',
                editable: false,
                style: { textAlign: 'center', fontSize: '11px' },
                headerStyle: () => {
                    return { textAlign: 'center', width: "20%", backgroundColor: '#12a420', color: 'white', fontSize: "11px" };
                },
            },
            {
                dataField: 'amount',
                text: 'Amount',
                editable: false,
                style: { textAlign: 'right', fontSize: '11px' },
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%", backgroundColor: '#12a420', color: 'white', fontSize: "11px" };
                },
                formatter: (cell) => {
                    return cell.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                }
            },
            {
                dataField: 'status',
                text: 'Status',
                editable: false,
                style: { textAlign: 'center', fontSize: '11px' },
                headerStyle: () => {
                    return { textAlign: 'center', width: "10%", backgroundColor: '#12a420', color: 'white', fontSize: "11px" };
                },
            }
        ];
    }

    componentDidMount() {

        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))

        this.handleGetMonitoringPayrollFiles();
        
    }

    handleGetMonitoringPayrollFiles() {
        this.setState({ isloading: true });

        const getParams = {
            IpAddress: "0.0.0.0",
            ClientId: "101",
            UserId: "84589",
            PayPeriodId: "38",
        };

        axios.post(AppConfiguration.Setting().noserapiendpoint + "Accounting/GetMonitoringPayrollFiles", getParams)
            .then(res => {
                const data = res.data;

                console.log("handleGetMonitoringPayrollFiles raw data:");
                console.log(data);

                const processedData = (data.payrollFiles || []).map(payfile => ({
                    client: payfile.client,
                    payFileId: payfile.payPeriodId,
                    payrollPeriod: payfile.payPeriod,
                    numberOfMembers: parseInt(payfile.totalTxn || 0, 10),
                    totalAmount: parseFloat((payfile.totalTxnAmount || "0").replace(/,/g, '')),
                    reference: payfile.referenceNumber,
                    paycardType: payfile.paycardType,
                    parentDetails: (payfile.payrollFileDetails || []).map(detail => ({
                        name: detail.memberName,
                        payFileId: detail.payrollFileId,
                        paycardType: payfile.paycardType,
                        payrollPeriod: payfile.payPeriod,
                        paycard: payfile.paycardType,
                        amount: parseFloat((detail.amount || "0").replace(/,/g, '')),
                        status: detail.status || "Good"
                    }))
                }));

                console.log("handleGetMonitoringPayrollFiles processedData:");
                console.log(processedData);

                this.setState({
                    monitoringPayrollData: processedData,
                    data: processedData,
                    filteredData: processedData,
                    isloading: false
                });
            })
            .catch(error => {
                this.setState({
                    isloading: false,
                    alerttype: "Error!",
                    isshow: true,
                    color: "danger",
                    message: "An error occurred while processing your request: " + error.message,
                    fade: true
                });
            });
    }

    parentSubRow = {
        renderer: row => (
            <div style={{ marginLeft: "50px" }}>
                <BootstrapTable
                    striped
                    hover
                    condensed
                    keyField="id"
                    data={row.parentDetails}
                    columns={this.parentDetailsColumn}
                    cellEdit={cellEditFactory({
                        mode: 'dbclick',
                        blurToSave: true,
                        afterSaveCell: (oldValue, newValue, row, column) => {
                        }
                    })}
                />
            </div>
        ),
        showExpandColumn: true,
        expandByColumnOnly: true
    };

    handleSearch() {
        const { data } = this.state;
        const client = document.getElementById('client').value.toLowerCase();
        const reference = document.getElementById('reference').value.toLowerCase();
        const payPerPeriod = document.getElementById('payPerPeriod').value.toLowerCase();
        const paycardType = document.getElementById('paycardType').value.toLowerCase();

        const filteredData = data.filter(item => {
            return (
                (!client || item.client.toLowerCase().includes(client)) &&
                (!reference || item.reference.toLowerCase().includes(reference)) &&
                (!payPerPeriod || item.payrollPeriod.toLowerCase().includes(payPerPeriod)) &&
                (!paycardType || item.paycardType.toLowerCase().includes(paycardType))
            );
        });

        this.setState({ filteredData });
    }

    handleClear() {
        
        document.getElementById('client').value = '';
        document.getElementById('reference').value = '';
        document.getElementById('payPerPeriod').value = '';
        document.getElementById('paycardType').value = '';

        
        this.setState({ filteredData: this.state.data });
    }

    // handleDownload = () => {
    //     const parentData = this.state.data.map(item => ({
    //         client: item.client,
    //         payFileId: item.paycardType,
    //         payrollPeriod: item.payrollPeriod,
    //         numberOfMembers: item.numberOfMembers,
    //         totalAmount: item.totalAmount,
    //         reference: item.reference
    //     }));

    //     const parentDetailsData = this.state.data.flatMap(item => item.members.map(member => ({
    //         name: member.name,
    //         payfileId: member.paycardType,
    //         payrollPeriod: member.payrollPeriod,
    //         paycard: member.paycard,
    //         amount: member.amount,
    //         status: member.status
    //     })));

    //     const csvData = [...parentData, ...parentDetailsData];
    //     return csvData;
    // }

    handleDownload = () => {
        const csvRows = [];
    
        
        csvRows.push([
            "CLIENT", "PAYCARD TYPE", "PAYROLL PERIOD", "# OF MEMBER", "TOTAL AMOUNT", "REFERENCE"
        ]);
    
        
        this.state.data.forEach(item => {
            
            csvRows.push([
                item.client,
                item.paycardType,
                item.payrollPeriod,
                item.numberOfMembers,
                item.totalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                item.reference
            ]);
    
            
            csvRows.push([
                "", "MEMBERS", "PAYROLL PERIOD", "PAYCARD", "AMOUNT", "STATUS"
            ]);
    
            
            item.parentDetails.forEach(detail => {
                csvRows.push([
                    "",
                    detail.name,
                    detail.payrollPeriod,
                    detail.paycard,
                    detail.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    detail.status
                ]);
            });
    
            
            csvRows.push([]);
        });
    
        
        const csvContent = csvRows.map(row => row.join(",")).join("\n");
    
        
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "payfilemonitoring.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    
    
    getParentSubRowConfig() {
        return {
            renderer: row => (
                <div style={{ marginLeft: "50px" }}>
                    <BootstrapTable
                        keyField="reference"
                        data={Array.isArray(row.parentDetails) ? row.parentDetails : []}
                        columns={this.parentDetailsColumn}
                        cellEdit={cellEditFactory({ mode: 'dbclick', blurToSave: true })}
                    />
                </div>
            ),
            showExpandColumn: true,
            expandByColumnOnly: true,
            expanded: this.state.expandedRows,
            onExpand: (row, isExpand) => {
                const payFileId = row.payFileId;
                this.setState({
                    expandedRows: isExpand ? [payFileId] : [] 
                });
            }
            // onExpand: (row, isExpand) => {
            //     const payFileId = row.payFileId;
            //     this.setState(prevState => {
            //         const expanded = isExpand
            //             ? [...prevState.expandedRows, payFileId]
            //             : prevState.expandedRows.filter(id => id !== payFileId);
            //         return { expandedRows: expanded };
            //     });
            // }
        };
    }

    handleExcelDownload = (row) => {
        const wb = XLSX.utils.book_new();
        const wsData = [];
    
        wsData.push(["CLIENT", "PAYCARD TYPE", "PAYROLL PERIOD", "# OF MEMBER", "TOTAL AMOUNT", "REFERENCE"]);
    
        
        wsData.push([
            row.client,
            row.paycardType,
            row.payrollPeriod,
            row.numberOfMembers,
            row.totalAmount,
            row.reference
        ]);
    
        wsData.push([]);
    
        
        wsData.push(["", "MEMBERS", "PAYROLL PERIOD", "PAYCARD", "AMOUNT", "STATUS"]);
    
        
        row.parentDetails.forEach(detail => {
            wsData.push([
                "",
                detail.name,
                detail.payrollPeriod,
                detail.paycard,
                detail.amount,
                detail.status
            ]);
        });
    
        const worksheet = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, worksheet, "Payfile Monitoring");
    
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${row.client}_payfile.xlsx`);
    };
    
    render() {
        return (
            <div>
                <Banner />
                <Container className="themed-container" fluid={true}>
                    <Card className="mt-5">
                        <Card.Header>Finance >> Payfile Monitoring</Card.Header>
                        <Card.Body>
                            <Form>
                                <Card>
                                    <Accordion defaultActiveKey="1">
                                        <div className="card-header-tab">
                                            <Accordion.Toggle as={Button} variant="link" eventKey="1" style={{color: "#FFFFFF"}}>
                                                SEARCH FILTER
                                            </Accordion.Toggle>
                                        </div>
                                        <Accordion.Collapse eventKey='1'>
                                            <Card.Body>
                                                <Form.Row>
                                                    <Col sm={1}>
                                                        <Form.Label style={{fontWeight : "bold"}} className='mt-1'>CLIENT</Form.Label>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Control
                                                            id="client"
                                                            name='searchClient'
                                                            type="text" 
                                                            autoComplete="off" 
                                                        />
                                                    </Col>
                                                    <Col sm={2}></Col>
                                                        <Col sm={1}>
                                                            <Form.Label style={{fontWeight : "bold"}} className='mt-1'>REFERENCE</Form.Label>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Control
                                                                id="reference"
                                                                name='searchReference'
                                                                type="text" 
                                                                autoComplete="off" 
                                                            />
                                                        </Col >
                                                </Form.Row>
                                                <Form.Row className='mt-3'>
                                                    <Col sm={1}>
                                                        <Form.Label style={{fontWeight : "bold"}} className='mt-1'>PAY PER PERIOD</Form.Label>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Control
                                                            id="payPerPeriod"
                                                            name='searchpayPerPeriod'
                                                            type="text" 
                                                            autoComplete="off" 
                                                        />
                                                    </Col>
                                                    <Col sm={2}></Col>
                                                        <Col sm={1}>
                                                            <Form.Label style={{fontWeight : "bold"}} className='mt-1'>PAYCARD TYPE</Form.Label>
                                                        </Col>
                                                        <Col sm={4}>
                                                            <Form.Control
                                                                id="paycardType"
                                                                name='searchpayFileID'
                                                                type="text" 
                                                                autoComplete="off" 
                                                            />
                                                        </Col >
                                                </Form.Row>
                                                    <ButtonToolbar className="mt-4">
                                                        <Button 
                                                            name='searchPayfileRecord'
                                                            variant="primary" 
                                                            className="ml-auto noser-button-mr1"
                                                            onClick={this.handleSearch} >
                                                            Search
                                                        </Button>
                                                        <Button 
                                                            name='clearSearchFields'
                                                            variant="success" 
                                                            className="noser-button" 
                                                            onClick={this.handleClear} >
                                                            CLEAR
                                                        </Button>
                                                    </ButtonToolbar>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Accordion>
                                </Card>
                            </Form>

                            <div className="mt-3">
                                <BootstrapTable
                                    striped
                                    hover
                                    condensed
                                    pagination={paginationFactory({ sizePerPageRenderer })}
                                    // keyField="payFileId"
                                    keyField="reference"
                                    name="parentTable"
                                    data={Array.isArray(this.state.filteredData) ? this.state.filteredData : []}
                                    columns={this.parentColumn}
                                    noDataIndication={() => <div>No record found.</div>}
                                    // expandRow={this.getParentSubRowConfig()}
                                    expandRow={{
                                        renderer: row => (
                                            <div style={{ marginLeft: "50px" }}>
                                                <BootstrapTable
                                                    // keyField="name"
                                                    keyField="reference"
                                                    data={row.parentDetails}
                                                    columns={this.parentDetailsColumn}
                                                    cellEdit={cellEditFactory({ mode: 'dbclick', blurToSave: true })}
                                                />
                                            </div>
                                        ),
                                        showExpandColumn: true,
                                        expandByColumnOnly: true,
                                        expanded: this.state.expandedRows,
                                        onExpand: (row, isExpand) => {
                                            const rowId = row.reference;
                                            this.setState(prevState => {
                                                const expandedRows = isExpand
                                                    ? [...prevState.expandedRows, rowId]
                                                    : prevState.expandedRows.filter(id => id !== rowId);
                                                return { expandedRows };
                                            });
                                        }
                                    }}
                                    
                                    cellEdit={cellEditFactory({ mode: 'dbclick', blurToSave: true })}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Container>
                <NoserLoading show={this.state.isloading} />
            </div>
        );
    }
}

export default PayfileMonitoring;